export default __webpack_public_path__ + "static/bg-star-af9e20766ba9fcf2c182a8eb5fe85800.png";